import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BookOpen, X } from "lucide-react";
import { useLessonGeneration } from "@/context/LessonGenerationContext";

export function LessonReadyToast() {
  const { readyLesson, dismiss } = useLessonGeneration();
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  const lessonPath = readyLesson
    ? `/learning/lesson/${readyLesson.domainId}/${readyLesson.lessonId}`
    : null;

  // Show toast whenever readyLesson is set AND user is not already on that lesson page
  const isOnLessonPage = lessonPath ? location.pathname === lessonPath : false;

  useEffect(() => {
    if (readyLesson && !isOnLessonPage) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [readyLesson, isOnLessonPage]);

  const handleGoToLesson = () => {
    if (!lessonPath) return;
    dismiss();
    navigate(lessonPath);
  };

  const handleClose = () => {
    setVisible(false);
    dismiss();
  };

  if (!visible || !readyLesson) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 z-50 w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 animate-in slide-in-from-bottom-4 fade-in duration-300 rounded-2xl shadow-2xl overflow-hidden bg-gradient-to-r from-indigo-600 via-purple-600 to-fuchsia-500 text-white"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-start gap-3 p-4">
        {/* Icon */}
        <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-white/20">
          <BookOpen className="h-5 w-5 text-white" />
        </div>

        {/* Body */}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-white">
            Your lesson is ready!
          </p>
          <p className="mt-0.5 truncate text-xs text-white/80">
            {readyLesson.lessonTitle}
          </p>

          <button
            onClick={handleGoToLesson}
            className="mt-3 inline-flex items-center gap-1.5 rounded-lg bg-emerald-500 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-emerald-400"
          >
            Go to lesson
          </button>
        </div>

        {/* Close */}
        <button
          onClick={handleClose}
          aria-label="Dismiss notification"
          className="flex-shrink-0 rounded-md p-1 text-white/70 transition-colors hover:bg-white/20 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
